import { jsx as _jsx } from "react/jsx-runtime";
// Adapted from Microsoft Elixir-Framework (MIT), v3.0.1164, aa6c10ab1882f8fa20c1da308e6c1fc6fe2fe5e9.
// Source: packages/fx/src/components/Editor/RichText/plugins/commandbar/ElxRichTextCommandBar.tsx. Local adaptations: Bug 38755929.
import React from 'react';
import { getButtons, KnownRibbonButtonKey } from 'roosterjs-react';
import { moreCommands } from 'roosterjs-react/lib/ribbon/component/buttons/moreCommands';
import { CommandBar, FocusZoneDirection, useTheme, mergeStyles, mergeStyleSets, } from '@fluentui/react';
import { commandBarStyles, getButtonStyles } from './ElxRichTextCommandBar.styles';
const ribbonClassName = mergeStyles({
    '& .ms-CommandBar': {
        padding: '0px',
    },
});
const rtlIcon = mergeStyles({
    transform: 'scaleX(-1)',
});
export const ElxRichTextCommandBar = (props) => {
    const { plugin, dir, readOnly, disabled, buttonItems } = props;
    const [formatState, setFormatState] = React.useState(null);
    const isRtl = dir == 'rtl';
    const knownButtons = React.useMemo(() => buttonItems === null || buttonItems === void 0 ? void 0 : buttonItems.reduce((filtered, btn) => {
        const knownBtn = KnownRibbonButtonKey[btn];
        if (knownBtn !== undefined) {
            filtered.push(knownBtn);
        }
        return filtered;
    }, []), [buttonItems]);
    const buttons = getButtons(knownButtons);
    const theme = useTheme();
    const onClick = React.useCallback((_, item) => {
        if (!readOnly && !disabled && item) {
            plugin === null || plugin === void 0 ? void 0 : plugin.onButtonClick(item.data, item.key, {});
        }
    }, [plugin, readOnly, disabled]);
    const onHover = React.useCallback((button, key) => {
        if (!readOnly && !disabled) {
            plugin.startLivePreview(button, key, {});
        }
    }, [plugin, disabled, readOnly]);
    const onDismiss = React.useCallback(() => {
        plugin.stopLivePreview();
    }, [plugin]);
    const flipIcon = React.useCallback((props, defaultRender) => {
        return _jsx("span", Object.assign({ className: rtlIcon }, { children: defaultRender && defaultRender(props) }));
    }, []);
    const commandBarItems = React.useMemo(() => {
        return buttons.map((button) => {
            var _a, _b, _c, _d;
            const selectedItem = formatState && ((_b = (_a = button.dropDownMenu) === null || _a === void 0 ? void 0 : _a.getSelectedItemKey) === null || _b === void 0 ? void 0 : _b.call(_a, formatState));
            const dropDownMenu = button.dropDownMenu;
            const result = Object.assign(Object.assign(Object.assign(Object.assign({ key: button.key, data: button, iconProps: {
                    iconName: button.iconName,
                }, onRenderIcon: isRtl && button.flipWhenRtl ? flipIcon : undefined, iconOnly: true, text: button.unlocalizedText, ariaLabel: button.unlocalizedText, role: button.isChecked ? 'menuitemcheckbox' : 'menuitem', canCheck: !!button.isChecked }, (button.isChecked ? { checked: !!(formatState && button.isChecked(formatState)) } : {})), { disabled: disabled || (formatState && ((_c = button.isDisabled) === null || _c === void 0 ? void 0 : _c.call(button, formatState))) || false }), (button.commandBarProperties || {})), { buttonStyles: mergeStyleSets(getButtonStyles(theme), (_d = button.commandBarProperties) === null || _d === void 0 ? void 0 : _d.buttonStyles) });
            if (dropDownMenu) {
                result.subMenuProps = Object.assign({ shouldFocusOnMount: true, focusZoneProps: { direction: FocusZoneDirection.bidirectional }, onMenuDismissed: onDismiss, onItemClick: onClick, onRenderContextualMenuItem: dropDownMenu.allowLivePreview
                        ? (props, defaultRenderer) => (_jsx("div", Object.assign({ onMouseOver: () => onHover(button, (props === null || props === void 0 ? void 0 : props.key) || '') }, { children: defaultRenderer && defaultRenderer(props) })))
                        : undefined, items: Object.keys(dropDownMenu.items).map((key) => ({
                        key: key,
                        text: dropDownMenu.items[key],
                        data: button,
                        canCheck: !!dropDownMenu.getSelectedItemKey,
                        checked: selectedItem == key || false,
                        className: dropDownMenu.itemClassName,
                        onRender: dropDownMenu.itemRender ? (item) => dropDownMenu.itemRender && dropDownMenu.itemRender(item, onClick) : undefined,
                    })) }, (dropDownMenu.commandBarSubMenuProperties || {}));
            }
            else {
                result.onClick = onClick;
            }
            return result;
        });
    }, [buttons, formatState, isRtl, onClick, onDismiss, onHover, disabled, theme, flipIcon]);
    React.useEffect(() => {
        const disposer = plugin === null || plugin === void 0 ? void 0 : plugin.registerFormatChangedCallback(setFormatState);
        return () => {
            disposer === null || disposer === void 0 ? void 0 : disposer();
        };
    }, [plugin]);
    const moreCommandsBtn = moreCommands;
    React.useEffect(() => {
        plugin.setDisabled(!!disabled);
        plugin.setReadOnly(!!readOnly);
    }, [readOnly, disabled, plugin]);
    return (_jsx(CommandBar, Object.assign({ items: commandBarItems }, props, { styles: mergeStyleSets(commandBarStyles, props.styles), className: ribbonClassName + ' ' + ((props === null || props === void 0 ? void 0 : props.className) || ''), overflowButtonProps: {
            ariaLabel: moreCommandsBtn.unlocalizedText,
        } })));
};
